"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PageOrder = void 0;
var PageOrder;
(function (PageOrder) {
    /** Ascending, nulls last */
    PageOrder["ASC"] = "ASC";
    /** Ascending, nulls first */
    PageOrder["ASC_NULLS_FIRST"] = "ASC_NULLS_FIRST";
    /** Ascending, nulls last -- same as `ASC` */
    PageOrder["ASC_NULLS_LAST"] = "ASC_NULLS_LAST";
    /** Descending, nulls first */
    PageOrder["DESC"] = "DESC";
    /** Descending, nulls first  -- same as `DESC` */
    PageOrder["DESC_NULLS_FIRST"] = "DESC_NULLS_FIRST";
    /** Ascending, nulls last */
    PageOrder["DESC_NULLS_LAST"] = "DESC_NULLS_LAST";
})(PageOrder = exports.PageOrder || (exports.PageOrder = {}));
//# sourceMappingURL=cursor-pagination.js.map